import loadable from '@loadable/component';

export const withLazyLoad = (callback) => (loadable(callback));
